module.exports = __webpack_public_path__ + "img/hoslogo17.cefbdd6d.png";